import { h, Component } from 'preact'
import Button from '../ui-components/Button'
import Table from '../table/Table'
import { Modal, ModalHeader, ModalBody, ModalFooter } from '../modal'

interface CustomerClient {
  id: string,
  name: string,
  clientId: string,
  createdAt: string
}

interface Props {
  onRevokeButtonClick: Function,
  clients: Array<CustomerClient>
}

interface State {
  clientToDelete: CustomerClient|null
}

class List extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = { clientToDelete: null }
  }

  render ({ clients, onRevokeButtonClick }: Props, { clientToDelete }: State) {
    const model = [{
      header: 'Label',
      accessor: 'label'
    }, {
      header: 'Client ID',
      accessor: 'client_id'
    }, {
      header: 'Created at',
      accessor: 'created_at'
    }, {
      header: 'Action',
      accessor: 'action'
    }]
    let self = this
    const rows = clients.map(client => (
      {
        label: client.name,
        client_id: client.clientId,
        created_at: client.createdAt,
        action: <Button onClick={() => self.setState({ clientToDelete: client })} danger>Delete</Button>
      }
    ))
    return <div class='oauth2-clients-list'>
      <h4>Generated OAuth2 Clients</h4>
      <Table model={model} rows={rows} narrow />
      <Modal isOpen={clientToDelete != null}>
        <ModalHeader title='Delete this client?' onClose={() => this.setState({ clientToDelete: null })} />
        <ModalBody>If you delete this client, it's gone for good</ModalBody>
        <ModalFooter>
          <Button onClick={() => this.setState({ clientToDelete: null }, onRevokeButtonClick(clientToDelete))} danger>Delete</Button>
          <Button onClick={() => this.setState({ clientToDelete: null })} default>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  }
}

export default List
